module.exports = __webpack_public_path__ + "static/media/S1N13-6.079add6a.svg";